import { simpleGqlClient } from '@/graphql/simple-client.jsx';

const q = async (query, variables = {}) => {
  const result = await simpleGqlClient.query(query, variables);
  if (result.errors?.length) {
    throw new Error(result.errors[0].message);
  }
  return result.data;
};

export const fetchDashboardInteligenciaOperativa = (filtros) =>
  q(
    `query($filtros: FiltrosInteligenciaOperativaInput){
      obtenerDashboardInteligenciaOperativa(filtros:$filtros){
        metricas { codigo etiqueta valor variante detalle }
        alertas {
          id sucursalId sucursalNombre tipo subtipo severidad estado titulo descripcion entidadTipo entidadId
          metadata relatedLabel detectadaEn recomendaciones quickActions
        }
        insights { codigo titulo descripcion severidad entidadTipo entidadId }
        rankingSucursales { id nombre total severidadMaxima }
        rankingChoferes { id nombre total severidadMaxima }
        tendencia7Dias { fecha total }
        resumenSeveridad { severidad total }
        sucursales { id nombre }
        lineas { id codigo nombre }
        configuraciones { id codigoRegla activa severidadDefault parametros etiqueta descripcion }
      }
    }`,
    { filtros },
  ).then((d) => d.obtenerDashboardInteligenciaOperativa);

export const fetchAlertasOperativas = (filtros, paginacion) =>
  q(
    `query($filtros: FiltrosInteligenciaOperativaInput, $paginacion: PaginacionOperativaInput){
      obtenerAlertasOperativas(filtros:$filtros, paginacion:$paginacion){
        total page perPage
        items {
          id sucursalId sucursalNombre tipo subtipo severidad estado titulo descripcion entidadTipo entidadId
          metadata relatedLabel detectadaEn recomendaciones quickActions
        }
      }
    }`,
    { filtros, paginacion },
  ).then((d) => d.obtenerAlertasOperativas);

export const fetchAlertaOperativa = (id) =>
  q(
    `query($id: ID!){
      obtenerAlertaOperativa(id:$id){
        id sucursalId sucursalNombre tipo subtipo severidad estado titulo descripcion entidadTipo entidadId
        metadata relatedLabel detectadaEn vistaEn resueltaEn descartadaEn recomendaciones quickActions
        historial { id estadoAnterior estadoNuevo comentario metadata usuarioAccionId createdAt }
      }
    }`,
    { id },
  ).then((d) => d.obtenerAlertaOperativa);

export const fetchConfiguracionAlertasOperativas = (sucursalId) =>
  q(
    `query($sucursalId: ID){
      obtenerConfiguracionAlertas(sucursalId:$sucursalId){
        id codigoRegla activa severidadDefault parametros etiqueta descripcion sucursalId
      }
    }`,
    { sucursalId },
  ).then((d) => d.obtenerConfiguracionAlertas || []);

export const recalcularAlertasOperativas = (filtros) =>
  q(
    `mutation($filtros: FiltrosInteligenciaOperativaInput){
      recalcularAlertasOperativas(filtros:$filtros){
        totalEvaluadas totalActivas nuevas actualizadas autoResueltas
      }
    }`,
    { filtros },
  ).then((d) => d.recalcularAlertasOperativas);

export const marcarAlertaComoVista = (id) =>
  q(
    `mutation($id: ID!){
      marcarAlertaComoVista(id:$id){ id estado vistaEn }
    }`,
    { id },
  ).then((d) => d.marcarAlertaComoVista);

export const resolverAlertaOperativa = (id, comentario) =>
  q(
    `mutation($id: ID!, $comentario: String){
      resolverAlertaOperativa(id:$id, comentario:$comentario){ id estado resueltaEn }
    }`,
    { id, comentario },
  ).then((d) => d.resolverAlertaOperativa);

export const descartarAlertaOperativa = (id, comentario) =>
  q(
    `mutation($id: ID!, $comentario: String){
      descartarAlertaOperativa(id:$id, comentario:$comentario){ id estado descartadaEn }
    }`,
    { id, comentario },
  ).then((d) => d.descartarAlertaOperativa);

export const actualizarConfiguracionAlertaOperativa = (input) =>
  q(
    `mutation($input: ActualizarConfiguracionAlertaOperativaInput!){
      actualizarConfiguracionAlerta(input:$input){
        id codigoRegla activa severidadDefault parametros etiqueta descripcion sucursalId
      }
    }`,
    { input },
  ).then((d) => d.actualizarConfiguracionAlerta);
